import React from 'react'

function OurExpertise() {
  return (
    <div>
      <div className='mx-auto p-6 text-center md:py-4'>
      <section className="w-full bg-white text-white rounded-lg">
      <div>
        <div className="gap-6 items-center">
          
          <div className="bg-white text-[#0C2340] p-6 rounded-lg">
            <h2 className="text-3xl md:text-4xl font-bold mb-2">
            OUR EXPERTISE
            </h2>
            <p className="text-lg md:text-xl">Expert Solutions to Support Your Success, Every Step of the Way</p>
            <div>
        </div>

          </div>
         
        </div>
     
      </div>
    </section>
    </div>
    </div>
  )
}

export default OurExpertise
